<template>
    <div :class="$style['system-page']">
        <div :class="$style['system-page__container']">
            <div :class="$style['system-page__error-name']">
                {{ t("error", { code: errorCode }) }}
            </div>
            <h1 :class="$style['system-page__title']">{{ title }}</h1>
            <div :class="$style['system-page__info']">
                <slot />
            </div>
        </div>
        <img :src="imgSrc" alt="picture" :class="$style['system-page__decor']" />
    </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

defineProps({
    imgSrc: {
        type: String,
        required: true,
        default: '',
    },

    errorCode: {
        type: String,
        default: '404',
    },

    title: {
        type: String,
        default: '',
    },
});

const { t } = useI18n();
</script>

<style lang="less" module>
@import (reference) "../../assets/styles/variables.less";
@import (reference) "@omnica/base/assets/stylesheets/palette.less";
@import (reference) "@omnica/base/assets/stylesheets/typography.less";

.system-page {
  display: flex;
  justify-content: space-between;
  height: 100%;
  padding: 180px 157px 96px;
  background-color: #FFFFFF;
  font-family: @font-family;
  line-height: 1.5;
  color: @black-500;
  position: relative;

  &__container {
    position: relative;
    max-width: 590px;
  }

  &__error-name {
    .text-small();
    margin-bottom: 24px;
  }

  &__title {
    font-family: @font-family-Gilroy;
    .h1-accent();
    margin-bottom: 32px;
  }

  &__info {
    font-size: 18px;
    font-weight: 400;
    line-height: 28px;
  }

  &__decor {
    align-self: flex-end;
  }

  p {
    margin-bottom: 16px;
  }
  @media screen and (max-width: @tablet) {
    padding: 0;
    flex-direction: column;
    justify-content: center;

    &__container {
      padding: 16px;
      margin: 0 auto;
    }

    &__decor {
      width: 100%;
      max-width: 400px;
      margin: 40px auto 0;
    }
  }

  @media screen and (max-width: @phone) {
    justify-content: flex-start;
  }
}
</style>

<i18n locale="ru_RU" lang="json">
{
  "error": "Ошибка {code}"
}
</i18n>

<i18n locale="en_GB" lang="json">
{
  "error": "Error {code}"
}
</i18n>

<i18n locale="es_ES" lang="json">
{
  "error": "Error {code}"
}
</i18n>
